// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createAdminPaymentCall = (client) => ({
    /**
     * `PUT /admin/payment-call/settings/:seller_id/platform`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminUpdatePaymentCallPlatformSettings
     * @source apps/backend/src/api/admin/payment-call/settings/[seller_id]/platform/route.ts
     */
    updateSettingsPlatform: (sellerId, body, query, headers) => client.fetch(buildPath("/admin/payment-call/settings/:seller_id/platform", [sellerId]), { method: "PUT", body, query, headers }),
});
//# sourceMappingURL=payment-call.js.map